import e from "@dialpad/dialtone-tokens/layered/themes/tokens-copper-colors.css?inline";
//#region themes/copper.js
var t = {
	brand: {
		css: e,
		name: "copper"
	},
	material: { name: "iron" }
};
//#endregion
export { t as default };
